import { PagedRequestDto } from '@umss/shared/data-access';
import { ContractorStatus } from '../../enums';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface ContractorAdminSearchDto extends PagedRequestDto {
  email?: string | null;
  phoneNumber?: string | null;
  scopeOfPractice?: ScopeOfPracticeEnum | null;
  stateCode?: string;
  status?: ContractorStatus | null;
  registeredDateFrom?: string | null; // DateTime as ISO string
  registeredDateTo?: string | null; // DateTime as ISO string
  hasActiveShifts?: boolean | null;
}
